import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducer";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewares = [thunk];
// if (process.env.NODE_ENV === `development`) {
//   const { logger } = require(`redux-logger`);
//   middlewares.push(logger);
// }
const persistConfig = {
  key: 'root',
  storage: storage,
  whiteList: [],
  blacklist: ['document', 'advice', 'user', 'attributes', 'group', 'agent'],
  stateReconciler: autoMergeLevel2 // 查看 'Merge Process' 部分的具体情况
};
const persistedReducer = persistReducer(persistConfig, reducers);
let store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(...middlewares)));
export const persistor = persistStore(store);
export default store;